import {memo, useMemo} from 'react';
import {useRouteMatch} from 'react-router-dom';
import {SettingsButton} from '~/ViewInvitation/components/Guestlist/SettingsButton';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {ChevronIcon} from '~library/svg/ChevronIcon';
import {CloseLineIcon} from '~library/svg/CloseLineIcon';

import * as styles from './GuestlistOverlayHeader.module.scss';

interface OverlayHeaderProps {
  onClose: () => void;
  goBack?: () => void;
}

export const GuestlistOverlayHeader = memo(({onClose, goBack}: OverlayHeaderProps) => {
  const onSummaryPage = !!useRouteMatch(`/guests/:userId`);
  const onUpdateGuestPage = useRouteMatch(`/guests/:userId/edit`)?.isExact;
  const onUpdateRSVPPage = useRouteMatch(`/guests/:userId/update-rsvp`)?.isExact;
  const onRsvpSettingsPage = useRouteMatch(`/guests/rsvp-settings`)?.isExact;

  const title = useMemo(() => {
    if (onSummaryPage || onRsvpSettingsPage || onUpdateRSVPPage || onUpdateGuestPage) {
      return (
        <Button
          data-qa-id="overlay-go-back-button"
          onClick={goBack}
          variant="transparent"
          title="Go back"
        >
          <ChevronIcon ratio={0.75} direction="left" />
          {onUpdateRSVPPage && <Typography variant="header5">Update RSVP</Typography>}
          {onUpdateGuestPage && <Typography variant="header5">Update contact</Typography>}
        </Button>
      );
    }
    return (
      <>
        <Typography variant="header5">Guest list</Typography>
        <SettingsButton />
      </>
    );
  }, [onUpdateGuestPage, onUpdateRSVPPage, onSummaryPage, goBack, onRsvpSettingsPage]);

  return (
    <div className={styles.guestlistOverlayTop}>
      <div className={styles.guestlistOverlayTitle}>{title}</div>
      {onRsvpSettingsPage && (
        <Typography variant="label1" color="pebble">
          RSVP Settings
        </Typography>
      )}
      <div>
        <Button
          variant="transparent"
          onClick={onClose}
          data-qa-id="close-guestlist-overlay"
          title="Close"
        >
          <CloseLineIcon ratio={0.75} />
        </Button>
      </div>
    </div>
  );
});

GuestlistOverlayHeader.displayName = 'GuestlistOverlayHeader';
